import { AuthService } from "./authService";
import { MockAuthService } from "./mockAuthService";
import { ApiAuthService } from "./apiAuthService";

let instance: AuthService | null = null;

export function getAuthService(): AuthService {
	if (!instance) {
		// Switch based on environment variable VITE_AUTH_MODE
		const mode = import.meta.env.VITE_AUTH_MODE || "mock";

		if (mode === "api") {
			instance = new ApiAuthService();
		} else {
			// Default to mock service for safety and backward compatibility
			instance = new MockAuthService();
		}

		console.log(`Auth service initialized in ${mode} mode`);
	}
	return instance;
}
